import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import type { SourcingRequestLineEntity } from './sourcing-request-line.entity';
import { SourcingRequestEntity } from './sourcing-request.entity';

@Index('sourcing_request__file__fk__file__id_fk', ['fkFileId'], {})
@Index(
	'sourcing_request__file__fk_sourcing_request__id_fk',
	['fkSourcingRequestId'],
	{},
)
@Index(
	'sourcing_request__file__fk_sourcing_request_line__id_fk',
	['fkSourcingRequestLineId'],
	{},
)
@Entity('sourcing_request__file')
export class SourcingRequestFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: '_fk_sourcing_request__id', unsigned: true })
	public fkSourcingRequestId!: number;

	/**
	 * Optional pin to a specific SR line. When null, the file attaches
	 * to the SR header (the original v1 behavior). When set, the file
	 * is associated with a specific line — used to keep vendor quote
	 * PDFs attached to the line they describe rather than the whole
	 * SR. Both attachment styles render in the same Files tab, with
	 * a pill indicating which line each line-attached file belongs to.
	 */
	@Column('int', {
		name: '_fk_sourcing_request_line__id',
		nullable: true,
		unsigned: true,
	})
	public fkSourcingRequestLineId!: number | null;

	@ManyToOne(
		() => SourcingRequestEntity,
		(sourcingRequest) => sourcingRequest.sourcingRequestFiles,
		{
			onDelete: 'CASCADE',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([
		{ name: '_fk_sourcing_request__id', referencedColumnName: 'id' },
	])
	public fkSourcingRequest!: SourcingRequestEntity;

	@ManyToOne('SourcingRequestLineEntity', {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([
		{ name: '_fk_sourcing_request_line__id', referencedColumnName: 'id' },
	])
	public fkSourcingRequestLine!: SourcingRequestLineEntity | null;

	@ManyToOne(() => FileEntity, (file) => file.sourcingRequestFiles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
